import React from 'react';
import Icon from '@ant-design/icons';

import RollUpSvg from './rollup.svg';
import { IconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const RollUpIcon = (props: IconComponentProps) => <Icon component={RollUpSvg} {...props} />;


